export default async () => {
    const components = [];

    // Busca todos los *Components.js en ./modules subcarpetas
    const modulesContext = require.context(
        './modules',
        true,
        /[A-Za-z]+\/[A-Za-z]+Components\.js$/ // Coincide con Care/CareComponents.js, Tracker/TrackerComponents.js, etc.
    );

    // Recorre los componentes de cada módulo detectado
    // eslint-disable-next-line no-restricted-syntax
    for (const key of modulesContext.keys()) {
        // eslint-disable-next-line no-await-in-loop
        const mod = await modulesContext(key);
        if (mod && mod.default) {
            components.push(...mod.default);
        }
    }

    return {
        components,
        getComponent(title) {
            return this.components.find((obj) => obj.title === title);
        },
    };
};
